import React from 'react';

const GameReviewControls = ({ ply, totalPlies, onPrevious, onNext, onExit }) => (
  <section className="review-controls" aria-label="Game review controls">
    <div className="review-controls__progress" aria-live="polite">
      <span>Review position</span>
      <strong>{ply} / {totalPlies}</strong>
    </div>
    <div className="review-controls__steps">
      <button type="button" onClick={onPrevious} disabled={ply === 0} aria-label="Previous move">
        <span aria-hidden="true">←</span>
        Previous
      </button>
      <button type="button" onClick={onNext} disabled={ply === totalPlies} aria-label="Next move">
        Next
        <span aria-hidden="true">→</span>
      </button>
    </div>
    <button className="review-controls__exit" type="button" onClick={onExit}>Return to final result</button>
    <p>Tip: use the <kbd>←</kbd> and <kbd>→</kbd> arrow keys.</p>
  </section>
);

export default GameReviewControls;
